import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useNavigate } from 'react-router-dom'; // Importer useNavigate
import API_URL from '../config';

const BookingForm = () => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState('');
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate(); // Initialiser useNavigate

  const location = useLocation();
  const roomIdFromURL = new URLSearchParams(location.search).get('roomId');

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const token = localStorage.getItem('token');

        // Vérifiez que le token existe et est une chaîne non vide
        if (!token || typeof token !== 'string') {
          console.warn('Token non valide ou non trouvé, redirection vers la connexion.');
          setMessage('Session expirée, veuillez vous reconnecter.');
          navigate('/login'); // Rediriger vers la page de connexion
          return;
        }

        const response = await axios.get(`${API_URL}/api/rooms`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRooms(response.data);

        if (roomIdFromURL) {
          setSelectedRoom(roomIdFromURL);
        }
      } catch (error) {
        console.error('Erreur lors du chargement des salles:', error);
        setMessage('Erreur lors du chargement des salles.');
      }
    };

    fetchRooms();
  }, [roomIdFromURL, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    // Vérifier le token JWT
    if (!token || typeof token !== 'string') {
      console.warn('Token non valide ou non trouvé, redirection vers la connexion.');
      setMessage('Vous devez être connecté pour effectuer une réservation.');
      navigate('/login'); // Rediriger vers la page de connexion
      return;
    }

    try {
      // Décoder le token JWT pour obtenir le userId
      const decodedToken = jwtDecode(token);
      const userId = decodedToken.id; // Assurez-vous que c'est bien un ObjectId côté backend

      // Combiner la date avec l'heure et formater en ISO 8601
      const startDateTime = new Date(`${date}T${startTime}`).toISOString();
      const endDateTime = new Date(`${date}T${endTime}`).toISOString();

      await axios.post(
        `${API_URL}/api/bookings`,
        { roomId: selectedRoom, startTime: startDateTime, endTime: endDateTime, userId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage('Réservation effectuée avec succès !');
    } catch (error) {
      console.error('Erreur lors de la réservation:', error);
      setMessage('Erreur lors de la réservation. Veuillez réessayer.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Réserver une Salle</h2>
      {message && <p>{message}</p>}
      <select value={selectedRoom} onChange={(e) => setSelectedRoom(e.target.value)} required>
        <option value="">Sélectionner une salle</option>
        {rooms.map((room) => (
          <option key={room._id} value={room._id}>
            {room.name}
          </option>
        ))}
      </select>
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
      <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} required />
      <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} required />
      <button type="submit">Réserver</button>
    </form>
  );
};

export default BookingForm;
